export class BillingDiscrepancyRequestType {
    ID: number;
    Name: string;
    RequestReasonIDs: string;
    RequiredAttachmentTypeIDs: string;
    Inactive: boolean;
}

export default BillingDiscrepancyRequestType;